export function parseVirtualCardMetadata(transaction: any) {
  if (transaction?.virtualCard?.operation) return transaction.virtualCard;

  try {
    const parsed =
      typeof transaction?.address === "string"
        ? JSON.parse(transaction.address)
        : transaction?.address;
    return parsed?.virtualCard || null;
  } catch {
    return null;
  }
}

export function virtualCardTransactionTitle(transaction: any) {
  switch (parseVirtualCardMetadata(transaction)?.operation) {
    case "card_creation":
      return "Card Creation";
    case "card_funding":
      return "Card Funding";
    case "card_closure":
      return "Card Balance Return";
    case "card_withdrawal":
      return "Card Withdrawal";
    default:
      return "Virtual Card";
  }
}
